"use client";

import { useEffect, useState } from "react";
import CaonaboVoiceButton, { type VoiceButtonProps } from "./CaonaboVoiceButton";

/** Solo monta el botón si la capa chat_voice está activa. */
export default function CaonaboVoiceButtonMaybe(props: VoiceButtonProps = {}) {
  const [enabled, setEnabled] = useState<boolean | null>(null);
  useEffect(() => {
    let cancel = false;
    fetch("/api/caonabo/status", { cache: "no-store" })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (!cancel) setEnabled(Boolean(data?.capas?.chat_voice));
      })
      .catch(() => {
        if (!cancel) setEnabled(false);
      });
    return () => {
      cancel = true;
    };
  }, []);
  if (!enabled) return null;
  return <CaonaboVoiceButton {...props} />;
}
